/* unplugin-vue-components disabled */import script from "./tinymce.vue?vue&type=script&setup=true&lang=js"
export * from "./tinymce.vue?vue&type=script&setup=true&lang=js"

import "./tinymce.vue?vue&type=style&index=0&id=c3088db4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3088db4"]])

export default __exports__